<template>
  <div class="about">
    <v-row dense class="pa-4 white--text mb-4 mt-3" style="background-color: #39C57B; margin: 0 1px">
      <v-col cols="12" lg="7" class="my-auto">
        <div class="body-1"> Pilih sekolah untuk <strong>Laporan PMO Sekolah</strong> </div>
      </v-col>
      <v-col cols="12" lg="5" class="text-right">
        <v-menu>
          <template v-slot:activator="{ attrs, on }">
            <v-btn depressed style="background-color: #FDFFCF; border-radius: 5pt" v-bind="attrs" v-on="on">
              <v-row dense>
                <v-col cols="10" class="text-left">
                  <p class="black--text my-auto">
                    {{ $getDeepObj(pelaksana, 'sekolah.nama') || '-' }}
                  </p>
                </v-col>
                <v-col cols="2" class="my-auto">
                  <v-icon right dark>mdi-chevron-down</v-icon>
                </v-col>
              </v-row>
            </v-btn>
          </template>
          <v-list dense>
            <v-list-item-group v-model="sekolahId" color="primary">
              <template v-for="(pelaksana, key) in pelaksanas || []">
                <v-divider v-if="key !== 0" :key="`divider-${key}`"></v-divider>
                <v-list-item :key="key" :value="$getDeepObj(pelaksana, 'sekolah.sekolah_id')" link>
                  <v-list-item-title>{{ $getDeepObj(pelaksana, 'sekolah.nama') }}</v-list-item-title>
                </v-list-item>
              </template>
            </v-list-item-group>
          </v-list>
        </v-menu>
      </v-col>
    </v-row>
    <v-card tile flat class="my-5">
      <v-card-text class="pa-0">
        <v-row no-gutters>
          <v-col cols="2">
            <div class="bg-kiri"></div>
          </v-col>
          <v-col cols="10" class="pa-5">
            <v-row>
              <v-col cols="12" md="6" sm="12">
                <v-list three-line>
                  <v-list-item class="px-0">
                    <v-list-item-avatar color="success" size="50">
                      <v-icon dark>mdi-home</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content class="py-0 px-1">
                      <v-list-item-title>
                        <v-label color="caption"><small>Nama Sekolah</small></v-label>
                      </v-list-item-title>
                      <v-list-item-subtitle v-if="$isObject(sekolah)">
                        <div class="body-1 black--text font-weight-medium">
                          {{ sekolah.nama }}
                        </div>
                      </v-list-item-subtitle>
                      <v-list-item-title>
                        <v-label color="caption"><small>Kelompok Pendampingan</small></v-label>
                      </v-list-item-title>
                      <v-list-item-subtitle v-if="$isObject(pspKpPa)">
                        <div class="body-1 black--text font-weight-medium">
                          {{ pspKpPa.nama || '' }}
                        </div>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-col>
              <v-col cols="12" md="6" sm="12">
                <div class="caption">Fasilitator Pendamping</div>
                <div class="body-2 black--text font-weight-medium">
                  {{ $getDeepObj(detail, 'psp_kp_pa_pendampingan.data.psp_profil_pa.data.ptk.data.nama') }}
                </div>
                <div class="caption">
                  Akun SIMPKB:
                  <span class="body-2 black--text font-weight-medium">
                    {{ $getDeepObj(detail, 'psp_kp_pa_pendampingan.data.psp_profil_pa.data.ptk.data.email') }}
                  </span>
                </div>
                <div class="caption">
                  SIMPKB ID Fasilitator:
                  <span class="body-2 black--text font-weight-medium">
                    {{ $getDeepObj(detail, 'psp_kp_pa_pendampingan.data.psp_profil_pa.data.ptk_id') }}
                  </span>
                </div>
                <div class="caption">
                  No WA Fasilitator:
                  <span class="body-2 black--text font-weight-medium">
                    {{ $getDeepObj(detail, 'psp_kp_pa_pendampingan.data.psp_profil_pa.data.no_wa') }}
                  </span>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card class="mt-5" elevation="0" tile flat>
      <v-card-text class="pa-7">
        <v-row class="mb-1">
          <v-col cols="12" lg="8" class="my-auto">
            <h3 class="black--text">Berikut Detail Jadwal Pertemuan</h3>
          </v-col>
          <v-col cols="12" lg="4" class="text-right">
            <v-chip color="success">Angkatan {{ pspKpPa.gelombang }} (tahun ke-{{ pspKpPa.tahun_ke }})</v-chip>
          </v-col>
        </v-row>
        <v-row dense class="pa-4 white--text" style="background-color: #39C57B">
          <v-col cols="12" lg="7" class="my-auto">
            <div class="body-1"> Pilih salah satu jadwal yang tersedia untuk melihat detail dari Jadwal Pertemuan </div>
          </v-col>
          <v-col cols="12" lg="5" class="text-right">
            <v-menu>
              <template v-slot:activator="{ attrs, on }">
                <v-btn depressed x-large style="background-color: #FDFFCF; border-radius: 5pt" v-bind="attrs" v-on="on">
                  <v-row dense>
                    <v-col cols="10" class="text-left">
                      <span style="font-size: 10px" class="text-lowercase grey--text text--darken-1">
                        <span class="text-capitalize">Jadwal</span> yang ditampilkan
                      </span>
                      <p class="black--text my-auto">
                        {{ mPendampingan[pendampinganKe || mPendampinganOpsi[0]] || '-' }}
                      </p>
                    </v-col>
                    <v-col cols="2" class="my-auto">
                      <v-icon right dark>mdi-chevron-down</v-icon>
                    </v-col>
                  </v-row>
                </v-btn>
              </template>
              <v-list dense>
                <v-list-item-group v-model="pendampinganKe" color="primary">
                  <template v-for="(pendampingan_ke, key) in mPendampinganOpsi">
                    <v-divider v-if="key !== 0" :key="`divider-${key}`"></v-divider>
                    <v-list-item :key="key" :value="pendampingan_ke" link>
                      <v-list-item-title>{{ mPendampingan[pendampingan_ke] }}</v-list-item-title>
                    </v-list-item>
                  </template>
                </v-list-item-group>
              </v-list>
            </v-menu>
          </v-col>
        </v-row>
        <v-list class="mt-6">
          <v-list-item>
            <v-list-item-content class="py-1">
              <v-row>
                <v-col cols="12" lg="6" class="my-auto">
                  <div style="font-size: 17px" class="blue--text">
                    Laporan PMO Periode {{ mPendampingan[pendampinganKe || mPendampinganOpsi[0]] }}
                  </div>
                  <div class="caption grey--text mt-1">
                    <em>
                      Anda wajib melengkapi
                      <span class="font-weight-medium grey--text text--darken-1">laporan pelaksanaan</span> dan
                      <span class="font-weight-medium grey--text text--darken-1">laporan tindak lanjut</span> untuk
                      melengkapi laporan PMO periode ini
                    </em>
                  </div>
                </v-col>
                <v-col cols="12" lg="3">
                  <div class="body-2 grey--text">Status Laporan</div>
                  <v-chip class="white--text" :color="+detail.is_lengkap === 1 ? 'green' : 'red'">
                    {{ +detail.is_lengkap === 1 ? 'Lengkap' : 'Belum' }}
                  </v-chip>
                </v-col>
              </v-row>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-list class=" mt-3 orange lighten-5">
                <v-list-item>
                  <v-list-item-content class="py-1">
                    <component
                      :is="isPeriodeEntry ? 'LaporanPmoPelaksanaan' : 'LaporanRefleksi'"
                      :is-edit="detailMeta.is_edit"
                      :pendampingan-ke="pendampinganKe || mPendampinganOpsi[0]"
                      :pelaksana="pelaksana"
                      :psp-kp-pa="pspKpPa"
                      :psp-kp-pa-id="pspKpPaId"
                      :detail="detail"
                      :detail-meta="detailMeta"
                      :masters="Object.assign({}, masters, { 'topik-opsi': topikOpsi, 'pic-opsi': picOpsi })"
                      @reload="onFetchPendampingan"
                    />
                  </v-list-item-content>
                </v-list-item>
                <v-divider class="my-4" />
                <v-list-item>
                  <v-list-item-content class="py-1">
                    <laporan-pmo-topik
                      :is-periode-entry="isPeriodeEntry"
                      :is-edit="detailMeta.is_edit"
                      :pendampingan-ke="pendampinganKe || mPendampinganOpsi[0]"
                      :pelaksana="pelaksana"
                      :psp-kp-pa="pspKpPa"
                      :psp-kp-pa-id="pspKpPaId"
                      :detail="detail"
                      :detail-meta="detailMeta"
                      :masters="Object.assign({}, masters, { 'topik-opsi': topikOpsi, 'pic-opsi': picOpsi })"
                      @reload="onFetchPendampingan"
                    />
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import LaporanPmoPelaksanaan from './components/LaporanPelaksanaan.vue';
import LaporanPmoTopik from './components/LaporanTopik.vue';
import LaporanRefleksi from './components/LaporanRefleksi.vue';

export default {
  name: 'LaporanPmoSekolah',
  components: { LaporanPmoPelaksanaan, LaporanPmoTopik, LaporanRefleksi },
  data() {
    return {
      attr: {
        endpoint: 'pendampingan-ks',
        cache: { 'pendampingan-ks': {} },
      },
      formulir: {},
      detail: {},
      detailMeta: {},
      sekolahId: null,
      pspKpPaId: null,
      pendampinganKe: null,
      topikOpsi: [],
      picOpsi: [],
    };
  },
  computed: {
    ...mapState('preferensi', {
      configPendampingan: (state) => (state.data && state.data.pendampingan && state.data.pendampingan['kp-pa']) || {},
    }),

    ...mapState('master', {
      masters: (state) => Object.assign({}, state.masters),
    }),

    ...mapState('laporan', {
      pelaksanas: (state) => state.pelaksanas || [],
      pelaksana: (state) => Object.assign({}, state.pelaksana),
      cache: (state) => Object.assign({}, state.cache),
    }),

    isPeriodeEntry() {
      if (!this.$isObject(this.pspKpPa)) {
        return true;
      }

      const periodeEntry = this.$getDeepObj(this.configPendampingan, 'pendampingan_ke-pmo-topik') || {};
      const periodeEntryAngkatan = periodeEntry[this.pspKpPa.gelombang] || [];

      return periodeEntryAngkatan.includes(+this.pendampinganKe);
    },

    pspKpPa() {
      return this.$getDeepObj(this.pelaksana, 'psp_kp_pa_sekolah.psp_kp_pa') || {};
    },

    sekolah() {
      return this.pelaksana.sekolah || {};
    },

    mPendampingan() {
      return this.pelaksana.pendampingan_ke || {};
    },

    mPendampinganOpsi() {
      return Object.keys(this.mPendampingan);
    },

    mProgresTopikOpsi() {
      const opsi = this.$getDeepObj(this.cache, 'pendampingan-ks/opsi.data.progres-topik') || [];

      return opsi.map((op) => {
        return {
          text: op.keterangan,
          value: op.k_kp_opsi_psp,
        };
      });
    },

    mPicOpsi() {
      const opsi = this.$getDeepObj(this.cache, 'pendampingan-ks/pic') || [];

      return opsi.map((pic) => {
        return {
          text: pic.nama,
          value: pic.ptk_id,
        };
      });
    },
  },
  async created() {
    await this.getMasters('kp_topik_psp;kp_subtopik_psp|value:k_kp_topik_psp+keterangan');

    await this.getOpsi();
    // await this.getPic();

    await this.fetchData();

    if (!this.pendampinganKe) {
      this.pendampinganKe = this.mPendampinganOpsi[0];
    }
  },
  methods: {
    ...mapActions('master', ['getMasters']),
    ...mapActions('laporan', ['fetch', 'updatePelaksana', 'getPelaksana', 'getDetail', 'getMasterPic']),

    async fetchData() {
      return await this.getPelaksana();
    },

    async getOpsi() {
      const { data } = await this.fetch({ attr: { endpoint: 'pendampingan-ks/opsi', cache: 'pendampingan-ks-opsi' } });
      this.topikOpsi = ((data && data['progres-topik']) || []).map((op) => {
        return {
          text: op.keterangan,
          value: op.k_kp_opsi_psp,
        };
      });
    },

    async getPic() {
      const opsi = await this.getMasterPic();
      this.picOpsi = (opsi || []).map((pic) => {
        return {
          text: pic.nama,
          value: pic.ptk_id,
        };
      });
    },

    onFetchPendampingan() {
      const pspKpPaId = this.pspKpPa.psp_kp_pa_id;
      const pendampinganKe = this.pendampinganKe || this.mPendampinganOpsi[0] || '';
      const endpoint = `pendampingan-ks/${pspKpPaId}/pelaksana/${this.pelaksana.psp_pelaksana_id}/fetch`;

      this.getDetail({ attr: { endpoint }, id: pendampinganKe }).then(({ data, meta }) => {
        this.detail = data;
        this.detailMeta = meta;
      });
    },

    onChangeSekolah() {
      this.updatePelaksana(this.sekolahId);
      this.pendampinganKe = this.mPendampinganOpsi[0];
    },

    async onChangePendampinganKe() {
      await this.onFetchPendampingan();
      await this.getPic();
    },
  },
  watch: {
    sekolahId: 'onChangeSekolah',
    pendampinganKe: 'onChangePendampinganKe',
  },
};
</script>
<style scoped>
.bg-kiri {
  background: #bbdefb;
  height: 100%;
}
.sc-notif {
  background-color: #c8e6c9;
}
</style>
